module.exports = __webpack_public_path__ + "img/complaintFollowUps.a2a38522.svg";